// TODO: Extract full content from App.js renderTabContent case 'how-it-works'  
// This is a placeholder - needs full extraction from lines 434-627
import React from 'react';
import { useTranslation } from 'react-i18next';
import GridAnimation from '../animations/GridAnimation';
import Tooltip from '../Tooltip';

const HowItWorksPage = () => {
  const { t } = useTranslation();

  return (
    <div className="content-section">
      <h2>{t("howItWorks.title")}</h2>
      <div className="how-it-works-layout">
        <div className="how-it-works-content model-documentation">
          <section className="model-intro">
            <h3>{t("howItWorks.overview.title")}</h3>
            <p>
              {t("howItWorks.overview.description")}
            </p>
          </section>
          
          <section className="model-data-collection">
            <h3>{t("howItWorks.dataCollection.title")}</h3>
            <div className="feature-card">
              <h4>{t("howItWorks.dataCollection.intelligence.title")}</h4>
              <p>
                {t("howItWorks.dataCollection.intelligence.description1")}
              </p>
              <p>
                {t("howItWorks.dataCollection.intelligence.description2")}
              </p>
              <div className="future-note">
                <span className="note-icon">🔮</span>
                <p>{t("howItWorks.dataCollection.intelligence.futureNote")}</p>
              </div>
            </div>
          </section>
          
          <section className="model-types">
            <h3>{t("howItWorks.modelSystem.title")}</h3>
            <p>{t("howItWorks.modelSystem.description")}</p>
            <div className="models-container">
              <div className="model-card">
                <div className="model-header">
                  <span className="model-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                      <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <h4>{t("howItWorks.modelSystem.marketCondition.title")}</h4>
                </div>
                <p>{t("howItWorks.modelSystem.marketCondition.description")}</p>
                <ul>
                  <li><strong>{t("howItWorks.modelSystem.marketCondition.hyper.name")}</strong> {t("howItWorks.modelSystem.marketCondition.hyper.description")}</li>
                  <li><strong>{t("howItWorks.modelSystem.marketCondition.prag.name")}</strong> {t("howItWorks.modelSystem.marketCondition.prag.description")}</li>
                </ul>
              </div>
              
              <div className="model-card">
                <div className="model-header">
                  <span className="model-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <h4>{t("howItWorks.modelSystem.analysis.title")}</h4>
                </div>
                <p>{t("howItWorks.modelSystem.analysis.description")}</p>
                <ul>
                  <li><strong>{t("howItWorks.modelSystem.analysis.euler.name")}</strong> {t("howItWorks.modelSystem.analysis.euler.description")}</li>
                  <li><strong>{t("howItWorks.modelSystem.analysis.tachyon.name")}</strong> {t("howItWorks.modelSystem.analysis.tachyon.description")}</li>
                  <li><strong>{t("howItWorks.modelSystem.analysis.aether.name")}</strong> {t("howItWorks.modelSystem.analysis.aether.description")}</li>
                  <li><strong>{t("howItWorks.modelSystem.analysis.val.name")}</strong> {t("howItWorks.modelSystem.analysis.val.description")}</li>
                </ul>
              </div>
              
              <div className="model-card">
                <div className="model-header">
                  <span className="model-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 6v6m0 4h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <h4>{t("howItWorks.modelSystem.aiEnhanced.title")}</h4>
                </div>
                <p>{t("howItWorks.modelSystem.aiEnhanced.description")}</p>
                <ul>
                  <li><strong>{t("howItWorks.modelSystem.aiEnhanced.riemann.name")}</strong> {t("howItWorks.modelSystem.aiEnhanced.riemann.description")}</li>
                  <li><strong>{t("howItWorks.modelSystem.aiEnhanced.sigma.name")}</strong> {t("howItWorks.modelSystem.aiEnhanced.sigma.description")}</li>
                </ul>
              </div>
              
              <div className="model-card">
                <div className="model-header">
                  <span className="model-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 1v6m0 6v6M23 12h-6M7 12H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M20.66 3.34l-4.24 4.24m0-8.48l4.24 4.24M3.34 20.66l4.24-4.24m0 8.48l-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <h4>{t("howItWorks.modelSystem.coordination.title")}</h4>
                </div>
                <p>{t("howItWorks.modelSystem.coordination.description")}</p>
                <ul>
                  <li><strong>{t("howItWorks.modelSystem.coordination.baek.name")}</strong> {t("howItWorks.modelSystem.coordination.baek.description")}</li>
                </ul>
              </div>
            </div>
          </section>
          
          <section className="model-training">
            <h3>{t("howItWorks.training.title")}</h3>
            <ol className="training-steps">
              <li>
                <h4>{t("howItWorks.training.initialization.title")}</h4>
                <p>{t("howItWorks.training.initialization.description")}</p>
              </li>
              <li>
                <h4>{t("howItWorks.training.convergence.title")}</h4>
                <p>{t("howItWorks.training.convergence.description")}</p>
                <div className="metrics-container">
                  <ul className="metrics-list">
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.rValue.term")}
                          description={t("howItWorks.training.metrics.rValue.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.sortino.term")}
                          description={t("howItWorks.training.metrics.sortino.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.sharpe.term")}
                          description={t("howItWorks.training.metrics.sharpe.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.drawdown.term")}
                          description={t("howItWorks.training.metrics.drawdown.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.cagr.term")}
                          description={t("howItWorks.training.metrics.cagr.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.winLoss.term")}
                          description={t("howItWorks.training.metrics.winLoss.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.volatility.term")}
                          description={t("howItWorks.training.metrics.volatility.description")}
                        />
                      </span>
                    </li>
                    <li>
                      <span className="metric">
                        <Tooltip 
                          term={t("howItWorks.training.metrics.kurtosis.term")}
                          description={t("howItWorks.training.metrics.kurtosis.description")}
                        />
                      </span>
                    </li>
                  </ul>
                </div>
                <p className="additional-metrics-note">
                  <em>{t("howItWorks.training.metrics.note")}</em>
                </p>
              </li>
              <li>
                <h4>{t("howItWorks.training.testing.title")}</h4>
                <p>{t("howItWorks.training.testing.description")}</p>
                <div className="testing-note">
                  <p>{t("howItWorks.training.testing.note")}</p>
                </div>
              </li>
              <li>
                <h4>{t("howItWorks.training.deployment.title")}</h4>
                <p>{t("howItWorks.training.deployment.description1")}</p>
                <p>{t("howItWorks.training.deployment.description2")}</p>
              </li>
            </ol>
          </section>
          
          <section className="model-consistency">
            <h3>{t("howItWorks.consistency.title")}</h3>
            <p>
              {t("howItWorks.consistency.description")}
            </p>
          </section>
        </div>
        <div className="how-it-works-animation">
          <GridAnimation />
        </div>
      </div>
    </div>
  );
};

export default HowItWorksPage;
